<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab :title="descPlural">
      <List />
    </CTab>
  </CTabs>
</template>

<script>
import { loadDescs } from "@/helpers/utils";
import List from "./components/List.vue";

export default {
  name: "regraNegocio",
  components: { List },

  data() {
    return {
      descPlural: "",
    };
  },

  beforeMount() {
    const { descPlural } = loadDescs("ADMIN_REGRA_NEGOCIO");
    this.descPlural = descPlural || "Regras de negócio";
  },
};
</script>

<style src="@/views/Cashback/cashback-tema.css"></style>
